// src/frontend/lib/socket.js
import {io} from 'socket.io-client';

export const socket = io({
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
});

socket.onAny((event, ...args) => {
    console.log(`[SOCKET →] ${event}`, args);
});